import React from 'react';

export const IconPosition = {
  LEFT: 'left',
  RIGHT: 'right'
};

const NavigationButton = ({ 
  label, 
  icon, 
  className, 
  onClick, 
  iconPosition = IconPosition.LEFT,
  identifier
}) => {
  if (!label && !icon) {
    return null;
  }

  const renderIcon = () => {
    if (!icon) return null;
    
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, { 
        className: `${className}-icon ${identifier ? `${className}-${identifier}-icon` : ''}`
      });
    }
    
    if (typeof icon === 'string') {
      return (
        <img src={icon} alt={label} className={`${className}-icon ${identifier ? `${className}-${identifier}-icon` : ''}`} />
      );
    }
    
    return null;
  };

  return (
    <button
      type="button"
      className={className + ` ${identifier ? `${className}-${identifier}` : ''}`}
      onClick={onClick}
    >
      {iconPosition === IconPosition.LEFT && renderIcon()}
      {label && <span className={`${className}-label ${identifier ? `${className}-${identifier}-label` : ''}`}>{label}</span>}
      {iconPosition === IconPosition.RIGHT && renderIcon()}
    </button>
  );
};

export default NavigationButton;